import trendingStores from './trendingStores';

export default trendingStores;
